export default __webpack_public_path__ + "static/media/Helm of the Revelations of Tarim.988da4eb.jpg";